var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.678,
    height: 17.688,
    viewBox: "0 0 17.678 17.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.057 -0.044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.057 0.044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.725,18.389H1.587c-.015-.015-.028-.038-.043-.043A.859.859,0,0,1,.9,17.423Q.9,9.54.9,1.657A1.226,1.226,0,0,1,.991,1.19.85.85,0,0,1,1.882.7Q7.967.7,14.053.7a2.066,2.066,0,0,1,.207.006.806.806,0,0,1,.75.65,1.825,1.825,0,0,1,.025.361q0,3.411,0,6.821v.19a4.918,4.918,0,0,0-1.959.038,5.33,5.33,0,0,0-4.217,5.226,5.094,5.094,0,0,0,1.531,3.656c.248.253.532.47.8.7H1.917a1.138,1.138,0,0,0-.191.035ZM7.958,4.234h.414c1.318,0,2.636-.013,3.952,0a.906.906,0,0,0,.829-1.349.878.878,0,0,0-.864-.422H3.659a1.736,1.736,0,0,0-.292.023.829.829,0,0,0-.695.9.906.906,0,0,0,.951.842C5.069,4.226,6.514,4.234,7.958,4.234ZM5.766,6.016h0C5,6.016,4.224,6,3.454,6.022A.825.825,0,0,0,2.71,7.133a.9.9,0,0,0,.951.641h4.2A2.043,2.043,0,0,0,8.1,7.756a.871.871,0,0,0,.754-.885.789.789,0,0,0-.769-.849C7.309,6,6.537,6.016,5.766,6.016Z",
    transform: "translate(-0.9 -0.702)",
    fill: "#008bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.961,233.552a1.956,1.956,0,0,1-.738-.543c-.288-.3-.583-.586-.873-.877a3.483,3.483,0,0,1-4.7-1.029,3.547,3.547,0,0,1,.462-4.512,3.5,3.5,0,0,1,4.656-.229,3.44,3.44,0,0,1,.812,4.528c.29.29.579.586.875.875a1.787,1.787,0,0,1,.541.751v.311a1.145,1.145,0,0,1-.76.725Zm-3.391-6.2a1.766,1.766,0,1,0,.015,3.533,1.766,1.766,0,0,0-.015-3.533Z",
    transform: "translate(-216.319 -215.864)",
    fill: "#008bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.464,409.175l.034.035H20a1.137,1.137,0,0,1,.191-.033Q24.827,409.174,29.464,409.175Z",
    transform: "translate(-19.175 -391.523)",
    fill: "#6f6f6f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.7a2baf95be9cc35d6de45d31afcb5bfe.svg";
export { ForwardRef as ReactComponent };